/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Measure_ResponseInputs */

const en_measure_response = /** @type {(inputs: Measure_ResponseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Response`)
};

const zh_hans1_measure_response = /** @type {(inputs: Measure_ResponseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`响应时间`)
};

const pt_br2_measure_response = /** @type {(inputs: Measure_ResponseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resposta`)
};

const es_measure_response = /** @type {(inputs: Measure_ResponseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respuesta`)
};

const fr_measure_response = /** @type {(inputs: Measure_ResponseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réponse`)
};

const de_measure_response = /** @type {(inputs: Measure_ResponseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antwort`)
};

const ru_measure_response = /** @type {(inputs: Measure_ResponseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ответ`)
};

const it_measure_response = /** @type {(inputs: Measure_ResponseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risposta`)
};

/**
* | output |
* | --- |
* | "Response" |
*
* @param {Measure_ResponseInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_response = /** @type {((inputs?: Measure_ResponseInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_ResponseInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_response(inputs)
	if (locale === "pt-BR") return pt_br2_measure_response(inputs)
	if (locale === "es") return es_measure_response(inputs)
	if (locale === "fr") return fr_measure_response(inputs)
	if (locale === "de") return de_measure_response(inputs)
	if (locale === "ru") return ru_measure_response(inputs)
	if (locale === "it") return it_measure_response(inputs)
	return en_measure_response(inputs)
});